import api from "../axios";


export const getCancelByDateApi = (
    branchid: string,
    fromdate: string,
    todate: string
) => {
    return api.get("/booking/getcancelbydate", {
        params: {
            branchid,
            fromdate,
            todate,
        },
    });
};

export const cancelBookingApi = (data: {
    bookingid: number;
    cancelreason: string;
    cancelledby: string;
}) => {
    return api.post("/booking/cancelbooking", data);
};

export const updateToNewBookingApi = (data: { bookid: number; updatedBy: string }) => {
    return api.post("/booking/updatetonewbooking", data);
};